import { Avatar } from "@mui/material";
import React, { useEffect } from "react";
import { tokens } from "styles/Tokens";
import { getInitials } from "utils/CommonFunctions";
import Typography from "../Typography";
import { colorProps } from "./colorProps";
import { variantProp } from "./variantProp";

interface Props {
  variant?: string;
  size?: string;
  user: any;
  index?: any;
  sizeProperty?: any;
  colorProperty?: any;
  zIndex?: number;
}

function AvatarItem(props: Props) {
  const { user, index, sizeProperty, colorProperty, variant, size, zIndex } = props;

  const [sizeProp, setSizeProp] = React.useState<any>();
  const [colorProp, setColorProp] = React.useState<any>();

  const avatarSrcStyle = {
    width: sizeProperty ? sizeProperty?.width : sizeProp?.width,
    height: sizeProperty ? sizeProperty?.height : sizeProp?.height
  };

  const avatarColorStyle = {
    width: sizeProperty ? sizeProperty?.width : sizeProp?.width,
    height: sizeProperty ? sizeProperty?.height : sizeProp?.height,
    background: colorProperty ? colorProperty?.bgColor : colorProp?.bgColor,
    color: colorProperty ? colorProperty?.textColor : colorProp?.textColor,
    border: colorProperty ? colorProperty?.borderStyle : colorProp?.borderStyle
  };

  useEffect(() => {
    setSizeProp(variantProp[size ?? "large"]);
    setColorProp(colorProps[variant ?? "colored"]);
  }, []);

  if (user?.src) {
    return (
      <Avatar
        key={index}
        sx={{
          ...avatarSrcStyle,
          zIndex,
          "&.MuiAvatar-root": {
            border: `1px solid ${tokens.Border.General.Inverse}`
          }
        }}
        src={user.src}
      />
    );
  }

  return (
    <Avatar
      key={user.id}
      sx={{
        ...avatarColorStyle,
        zIndex,
        ".MuiAvatarGroup-root &.MuiAvatar-root": {
          border: colorProperty?.borderStyle || colorProp?.borderStyle
        }
      }}
      className="new-avatar"
    >
      <Typography sx={{ fontSize: sizeProperty?.fontSize || sizeProp?.fontSize }} variant="body2" showBold>
        {getInitials(user)}
      </Typography>
    </Avatar>
  );
}

export default AvatarItem;
